import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig, HammerModule } from '@angular/platform-browser';

import { CasinoPlatformLoaderModule } from '@casinocore/loader';
import { STORE_PREFIX, runOnAppInit } from '@frontend/vanilla/core';
import { GlobalSearchModule } from '@globalsearch/productstub';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import * as Hammer from 'hammerjs';

import { HtmlBootstrapService } from './html/html-bootstrap.service';

class HammerConfig extends HammerGestureConfig {
    override overrides = <any>{
        swipe: { enable: true, direction: Hammer.DIRECTION_ALL },
        pan: { enable: true, direction: Hammer.DIRECTION_ALL },
    };
}

export function provideBingo(): EnvironmentProviders {
    return makeEnvironmentProviders([
        { provide: HAMMER_GESTURE_CONFIG, useClass: HammerConfig },
        { provide: STORE_PREFIX, useValue: 'bingo.' },
        { provide: MatDialogRef, useValue: {} },
        { provide: MAT_DIALOG_DATA, useValue: [] },
        runOnAppInit(HtmlBootstrapService),
        importProvidersFrom(
            HammerModule,
            GlobalSearchModule.forRoot(),
            CasinoPlatformLoaderModule.forRoot(),
            StoreModule.forRoot(undefined, {
                runtimeChecks: {
                    strictStateImmutability: false,
                    strictActionImmutability: false,
                    strictStateSerializability: false,
                    strictActionSerializability: false,
                },
            }),
            EffectsModule.forRoot([]),
        ),
    ]);
}
